export const getBackendNotifications = (state: RootState) => state.app.notifications ?? []
